import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { Constants } from '@shared/models';
import { ViewBasePage } from '@shared/pages';

@Component({
    'selector': 'app-contactUs',
    'templateUrl': './contactUs.page.html',
    'styleUrls': ['./contactUs.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class ContactUsPage extends ViewBasePage implements OnInit {
    public contactUs: any = {};

    constructor(injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(Constants.VIEW_CONTACT_US);
    }

    public override ngOnInit(): void {
        this.contactUs = {
            'phoneNumber': Constants.COMPANY_PHONE_NUMBER,
            'companyHours': Constants.COMPANY_HOURS,
            'website': Constants.COMPANY_WEBSITE,
            'emailAddress': Constants.COMPANY_SUPPORT_EMAIL_ADDRESS,
            'helpdesk': Constants.COMPANY_HELPDESK,
            'maintenanceHours': Constants.MAINTENANCE_HOURS
        }
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-contact-us-tour');
    }
}
